/**
 * Returns the client URL from the environment variables
 * - There isn't a direct client URL variable, so we need to use the
 *   Auth0 callback URL and remove the "/callback" from it
 * @returns {string} The client URL
 */
export const getClientUrl = () => {
  return import.meta.env.VITE_AUTH0_CALLBACK_URL.replace("/callback", "");
};
